import { render } from "./serviceDeal.vue?vue&type=template&id=53a57dca&scoped=true"
import script from "./serviceDeal.vue?vue&type=script&lang=js"
export * from "./serviceDeal.vue?vue&type=script&lang=js"

import "./serviceDeal.vue?vue&type=style&index=0&id=53a57dca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a57dca"]])

export default __exports__